import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User sends a prompt in Agent Chat',
  name: 'canvas_agent_chat_prompt_sent',
  params: [
    {
      description: 'The length of the message sent',
      name: 'message_length',
      required: true,
      type: 'number',
    },
    {
      description: 'The ID of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the chat thread',
      name: 'thread_id',
      required: true,
      type: 'string',
    },
    {
      description:
        'Where the prompt was sent from (the canvas toolbar, a gallery Edit in Canvas handoff, empty-canvas hero, or chat sidebar)',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['canvas_toolbar', 'edit_in_canvas', 'empty_state', 'sidebar'],
    },
    {
      description:
        'Slash commands of the skills in the message (one per matched skill; empty if none); matches skill_invoked.slash_command',
      name: 'slash_commands',
      required: true,
      type: 'array',
      values: ['string'],
    },
  ],
};

export default META;
